<template>
  <gd-modal ref="upgradeModal" name="upgrade" title="Upgrade to PRO today">
    <div class="flex flex-col items-center justify-center p-8">
      <p
        class="text-lg leading-loose mb-8 text-grey-800 text-center"
        v-html="upgradeMessage"
      ></p>
      <p
        class="text-lg leading-loose mb-8 text-grey-800 text-center"
        v-html="$t('frontend_upgrade_message')"
      ></p>
      <div class="flex flex-col items-center justify-center">
        <a
          :href="localizationTrackUrl()"
          target="_blank"
          class="
            flex
            items-center
            px-6
            py-3
            heading-sm
            focus:outline-none
            shadow
            hover:shadow-lg
            focus:shadow-lg
            rounded-lg
            bg-green-extra-dark
            text-white
            border-green-extra-dark border border-solid
            text-lg
          "
          >{{ $t('frontend_builder_shared_upgrade_modal_see_all') }}</a
        >
        <button class="mb-10 mt-6" @click="$refs.upgradeModal.close()">
          {{ $t('frontend_builder_shared_upgrade_modal_no_thanks') }}
        </button>
      </div>
    </div>
  </gd-modal>
</template>
<script>
import auth from '@groovepages/gd-lib/auth';
import { vsprintf } from 'sprintf-js';
import GdButton from './Button';
import GdModal from './Modal';

export default {
  components: {
    GdModal,
    GdButton
  },
  props: {
    upgradeReason: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    upgradeMessage() {
      let args = [];
      if (this.upgradeReason?.action === 'groovepages_total_pages') args = [this.upgradeReason.current, this.upgradeReason.allowed];
      else if (this.upgradeReason?.action === 'groove_projects') args = [this.upgradeReason.allowed];

      return this.upgradeReason?.action ? vsprintf(this.$t(`upgrade_${  this.upgradeReason.action}`), args) : null;
    }
  },
  methods: {
    open() {
      this.$refs.upgradeModal.open();
    },
    localizationTrackUrl() {
      const user = auth.authenticatedUser();
      return window.gdEnv[`UPGRADE_URL_${user?.metadata?.region?.toUpperCase()}`] || window.gdEnv.UPGRADE_URL;
    }
  }
};
</script>
